import basicRequest from "../../../../core/redux/actions/request";

const PREFIX = "COMMON_STORAGE_INIT";
const getState = (state) => state.common.storage.init;

const {
    getPattern,
    error,
    loading,
    success,
    reset,

    isLoaded,
    isLoading,
    getError,
    getData,
} = basicRequest(PREFIX, getState);

export { reset, isLoading, isLoaded, getError, getData };

export const isStorageLoading = (state) => isLoading(state);
export const getStorageData = (state) => getData(state);
export const isStorageAvailable = (state) =>
    isLoaded(state) && !isLoading(state) && getData(state)?.enabled && getData(state)?.mode === "radix";
export const isOldStorageAvailable = (state) =>
    isLoaded(state) && !isLoading(state) && getData(state)?.enabled && getData(state)?.mode === "box";

export const initStorage = () => getPattern("common/file-manager/v1/storage", {}, null);
